module.exports = "/_next/static/images/setpopup-0157f88153ee4d2b37567acc4e579521.png";